//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormTab from "@/0/components/comForm/comTab/comFormDetailTab.vue";
import FormGroupView from "@/0/components/comForm/comFormDetailGroupView";

export default {
  props: ["controlViewList", "groupViewList", "dataConfig"],
  components: {
    "form-tab": FormTab,
    "form-group-view": FormGroupView,
  },
  data() {
    return {};
  },
  created() {},
  methods: {

    $getComPage(){
      return this.$parent.$getComPage();
    },


    $getSubmitData() {
      var formData = {};
      return formData;
    },
    getSubmitData() {
      return this.$getSubmitData();
    },

    $getActionObj(){
      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },
    
  }
};
